module.exports = ".mci {\n    width: 100%;\n}\n\n.fechaPago {\n    width: 100%;\n}\n\n.periodos {\n    width: 20%;\n}\n\n.error {\n    color: red;\n}\n"